import * as m from "mithril";
import { MessageProvider } from '../../../context/AppMessages';
import '../SmallCarAdsCard.scss';
import {TripResultDTO } from "../../../apiclient/ApiDtos";
import SearchCriteria from "../../../models/SearchCriteria";
import dayjs = require("dayjs");
interface Attrs {
    searchCriteria: SearchCriteria,
    smallCarSampleImageUrlPath: string,
    tripResults: TripResultDTO[],
    messageProvider: MessageProvider,
    onClickToView: () => void
}

function SmallCarTripsAds(): m.Component<Attrs> {

    return {
        view(vnode) {

            const durations = Object.values(vnode.attrs.tripResults)
                .flat()
                .map(t =>
                    dayjs(t.arrival.scheduledAt)
                        .diff(dayjs(t.departure.scheduledAt))
                );

            const hasSameETA = new Set(durations).size == 1;

            const etaMs = dayjs(vnode.attrs.tripResults[0].arrival.scheduledAt).diff(
                dayjs(vnode.attrs.tripResults[0].departure.scheduledAt));
            const totalMinutes = Math.floor(etaMs / 60000);

            const inHourAndMin = {
                hours: Math.floor(totalMinutes / 60),
                minutes: totalMinutes % 60,
            };



            const minAmounts = vnode.attrs.tripResults.map(trip => trip.priceRange.min.amount);
            const lowestPrice = Math.min(...minAmounts);
            const currency = vnode.attrs.tripResults[0]?.priceRange.min.currency || 'MMK';
            const formattedPrice = lowestPrice.toLocaleString();
            const formattedMinPrice = `${currency} ${formattedPrice}`;


            const tripSample = vnode.attrs.tripResults[0];
            return [
                m("div.card.shadow-sm.mx-1.mb-3.mt-3.glow", {
                    style: "border-radius: 8px;"
                },
                    m("div.card-body.p-2",
                        m("div.d-flex.justify-content-between",
                            m("div",
                                m("img.operator-logo-sm", {
                                    style: {
                                        maxHeight: "110px",
                                        objectFit: "contain"
                                    },
                                    src: vnode.attrs.smallCarSampleImageUrlPath
                                })
                            ),

                            m("div.ml-2.p-2.flex-grow-1",
                                m("div.text-primary", {
                                    style: "font-size: 0.8rem; font-weight: 700 !important;"
                                },
                                    vnode.attrs.messageProvider.get("samll_car_ads_description")
                                ),

                                m("div.text-secondary",
                                    m("span", {
                                        style: "font-size: 0.8rem;"
                                    },
                                        vnode.attrs.messageProvider.get("samll_car_ads_tips")
                                    )
                                ),

                                m("div.mt-2.d-flex.justify-content-end",
                                    m("button.btn.btn-sm.btn-outline-primary.bounce-btn-animation.px-2", {
                                        onclick: (event: Event) => {
                                            event.preventDefault();
                                            vnode.attrs.onClickToView();
                                        },
                                        style: "border-radius: 8px !important;"
                                    },
                                        m("small.font-weight-bold fw-bold",
                                            vnode.attrs.messageProvider.get("view")
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ];
        }
    }
};

export default SmallCarTripsAds;